import {patchState, signalStoreFeature, withHooks} from "@ngrx/signals";
import {GenericApiService} from "../../api/generic-api.service";
import {inject, resource, Signal} from "@angular/core";
import {extractRelevantData} from "../../util/extract";

/**
 * Fetch data from API onInit
 *
 *
 * @example
 * ```typescript
 *  export const store = signalStore(
 *      {providedIn: 'root'},
 *      withState<StateType>()
 *      fetchOnInit<StateType, ['stateKey'], PromisedEntityType>('/api/url', ['stateKey'])
 *  )
 *
 *  //remember to include to main.ts to activate Oninit on app launch
 *  provideAppInitializer(() => {
 *    inject(store)
 *  }),
 * ```
 *
 * @param apiUrl
 * @param stateKeys
 * @param criteria
 * @param validation
 */
export function fetchOnInit<State, stateKeys extends (keyof State | keyof Entity)[], Entity> (
    apiUrl: string,
    stateKeys: stateKeys,
    criteria: Signal<any> = undefined,
    validation: Function = ( ...ags: any ) => { }
) {

    return  signalStoreFeature(

        withHooks((
            store,
            http = inject(GenericApiService)
        ) => ({

            onInit: ()=>{

                resource({
                    // request listener applies loader when criteria changes
                    request: criteria,

                    // loader function applies on initialization and when request listener is triggered
                    loader: async () => http.get< Array<Entity> | Entity >( apiUrl ).subscribe( ( data: Array<Entity> | Entity ) => {

                        validation(data);

                        if(data instanceof Array && stateKeys.length < 2) {
                            patchState(store, { [stateKeys[0]]: data })
                            return;

                        }else if (data instanceof Array && stateKeys.length > 1) {
                            throw new Error('State keys length must be 1 when returned data is an array')

                        }

                        const extractedData = extractRelevantData<Entity, any>(data, stateKeys as (keyof Entity)[]);
                        patchState(store, extractedData)
                        return;

                    })

                })

            }

        }))
    )

}